export const Escalator = (): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#363BC4"
      d="M7.273 5.817a1.816 1.816 0 0 1 2.173-1.782 1.82 1.82 0 0 1 1.325 2.478 1.817 1.817 0 0 1-3.498-.696m1.236 14.174H6.545A2.546 2.546 0 0 1 4 17.447a2.543 2.543 0 0 1 2.545-2.544h.364v-4.361a2.18 2.18 0 0 1 2.182-2.18 2.183 2.183 0 0 1 2.182 2.18v.727l1.498-1.684a3.64 3.64 0 0 1 2.72-1.224h1.963A2.546 2.546 0 0 1 20 10.905a2.543 2.543 0 0 1-2.546 2.544h-1.163a.73.73 0 0 0-.544.245L11.23 18.77a3.64 3.64 0 0 1-2.72 1.22m-.145-5.451 1.454-1.636v-2.362a.727.727 0 0 0-1.454 0zm-1.819 3.997H8.51a2.18 2.18 0 0 0 1.63-.732l4.517-5.078a2.18 2.18 0 0 1 1.635-.732h1.163a1.091 1.091 0 1 0 0-2.18h-1.963a2.18 2.18 0 0 0-1.63.732l-4.517 5.078a2.18 2.18 0 0 1-1.635.732H6.545a1.091 1.091 0 1 0 0 2.18"
    />
  </svg>
);
